import capitalize from "lodash/capitalize";
import deburr from "lodash/deburr";

export const getInitial = (name?: string) => {
  if (!name) return "";
  if (typeof name !== "string") return "";

  return name.trim().charAt(0) + ".";
};

export const nameWithFirstLastnameInitial = (name?: string, lastname?: string) => {
  if (!name) return "";
  if (typeof name !== "string") return "";

  const sanitizedName = name.trim();

  if (!lastname) return sanitizedName;
  if (typeof name !== "string") return sanitizedName;

  const sanitizedLastname = lastname.trim();

  return sanitizedName + " " + getInitial(sanitizedLastname);
};

export const getInitials = (name: string): string => {
  const sanitizedName = name.trim().split(" ");

  if (sanitizedName[1]) {
    return `${sanitizedName[0][0]}${sanitizedName[1][0]}`.toUpperCase();
  }

  return `${sanitizedName[0][0]}`.toUpperCase();
};

export const getFirstName = (name?: string, capitalized = true) => {
  if (!name) return "";
  if (typeof name !== "string") return "";

  const sanitizedName = name.trim();
  const [firstName] = sanitizedName.split(" ");

  if (!capitalized) {
    return firstName;
  }

  return capitalize(firstName);
};

export const getLastName = (lastname?: string, capitalized = true) => {
  if (!lastname) return "";
  if (typeof lastname !== "string") return "";

  const sanitizedLastname = lastname.trim();
  const lastName = sanitizedLastname.split(" ").pop();

  if (!capitalized) {
    return lastName;
  }

  return capitalize(lastName);
};

export const getFirstAndLastName = (fullName?: string) => {
  const firstName = getFirstName(fullName);
  const lastName = getLastName(fullName);

  return firstName + " " + lastName;
};

export const getFirstAndFirstLastName = (name?: string, lastname?: string) => {
  if (!name && !lastname) return "";

  const sanitizedName = typeof name === "string" ? name.trim() : "";
  const sanitizedLastname = typeof lastname === "string" ? lastname.trim() : "";

  const firstName = sanitizedName ? sanitizedName.split(/\s+/)[0] : "";
  const firstLastName = sanitizedLastname ? sanitizedLastname.split(/\s+/)[0] : "";

  if (firstName && firstLastName) {
    return `${firstName} ${firstLastName}`;
  }

  return firstName || firstLastName || "";
};

export const sanitizeForSearch = (text: string) => {
  const deburred = deburr(text);
  const lowercase = deburred.toLowerCase();
  const final = lowercase
    .replace(/[^a-z\s]/g, "") // Deletes special characters
    .replace(/\s+/g, " ")
    .trim(); // Replace multiple spaces

  return final;
};


export function stringToColor(string: string) {
  const colors = ["#015FEE", "#10B981", "#F59E0B", "#EF4444", "#8B5CF6", "#EC4899"];
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash) % colors.length;
  return colors[index];
}
